var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeetingBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6581 5.79667C20.2545 5.60353 19.8036 5.52731 19.3578 5.57688C18.912 5.62645 18.4896 5.79977 18.1399 6.07667L16.1033 7.68667V6.33333C16.1033 5.71449 15.8538 5.121 15.4097 4.68342C14.9656 4.24583 14.3633 4 13.7352 4H2.36814C1.74007 4 1.13772 4.24583 0.693612 4.68342C0.2495 5.121 0 5.71449 0 6.33333V15.6667C0 16.2855 0.2495 16.879 0.693612 17.3166C1.13772 17.7542 1.74007 18 2.36814 18H13.7352C14.3633 18 14.9656 17.7542 15.4097 17.3166C15.8538 16.879 16.1033 16.2855 16.1033 15.6667V14.3133L18.1399 15.9233C18.5608 16.256 19.0844 16.4371 19.624 16.4367C19.982 16.4354 20.3352 16.3557 20.6581 16.2033C21.0596 16.0131 21.3985 15.7152 21.6359 15.3437C21.8732 14.9722 21.9995 14.5423 22 14.1033V7.88889C21.998 7.45124 21.8711 7.02298 21.6338 6.65302C21.3965 6.28306 21.0584 5.98631 20.6581 5.79667Z",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingBold);
export default __webpack_public_path__ + "static/media/meeting-bold.dfac4e626af132493a8b247dec77965d.svg";
export { ForwardRef as ReactComponent };